/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
'use strict';

/**
 * Filter module related to mobile.
 */
angular
  .module('filters.mobile', [])
  /**
   * Filter used for getting an html block to represent a batch.
   */
  .filter('mobileBatchMessage', function ($filter, MOBILE_ICON_CLASS, RESULT_KEYS) {
    /**
     * Filter that takes a batch JSON object and converts it into a block of html
     * for display.
     *
     * @param {Object} action - A batch JSON object.
     * @return {String} - An html string representing a batch.
     */
    return function (action) {
      return $filter('i18n')('MOBILE_LOG_TEMPLATE', [
        MOBILE_ICON_CLASS[action.status] || MOBILE_ICON_CLASS.PARTIAL,
        $filter('i18n')(action.type || 'BACKUP'),
        $filter('i18n')(RESULT_KEYS[action.status]),
        $filter('shortHumanizeFilter')(action.endDate)
      ]);
    };
  });
